import React from 'react'
import { Fixed } from '@/src/components/parts/bases/Fixed'
import { VStack } from '@/src/components/parts/bases/VStack'
import { Text } from '@/src/components/parts/bases/Text'
import { Absolute } from '@/src/components/parts/bases/Absolute'
import { Clickable } from '@/src/components/parts/bases/Clickable'
import { Center } from '@/src/components/parts/bases/Center'
import { PinkNeonButton } from '@/src/components/parts/buttons/PinkNeonButton'
import Image from 'next/image'
import { ScrollFixedView } from '../../../RankingPage/components/scrollFixedView'
import { GameInfo } from '@/src/stores/Games/useGames'
import { S3URLService } from '@/src/services/S3URLService'

type GameCategory = 'HOT_GAME' | 'ALL_GAME'

export type Props = {
  visible: boolean
  hotGames: Array<GameInfo>
  allGames: Array<GameInfo>
  selectedGame: string
  selectGame: string
  selectCategory: GameCategory
  onClickGame: (gameId: string, selectCategory: GameCategory) => void
  onClickClose: () => void
  onClickAccept: () => void
}

export const Layout = (props: Props) => {
  return (
    <>
      {props.visible ? (
        <Fixed className="left-0 top-0 z-[100] h-full w-full overflow-scroll bg-black bg-opacity-70 pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]">
          <style global jsx>{`
            body,
            html {
              overflow: hidden;
            }
          `}</style>
          <VStack className="mx-6 my-20 rounded-[10px] border border-neon-blue bg-black pl-4 pr-2">
            <Text className="mt-4 text-center text-lg font-bold text-neon-blue">Select games</Text>
            <ScrollFixedView displayPosition="top" className="top-[60px]" />
            <VStack className="gray_scroll_bar mb-3 mt-4 flex-1 overflow-x-hidden overflow-y-scroll py-4">
              <Text className="mb-2 text-left text-base font-bold text-neon-blue">Hot games</Text>
              <div className="grid grid-cols-3 gap-4 pr-2">
                {props.hotGames.map((g) => (
                  <GameContent key={`HOT_GAME_${g.id}`} game={g} category="HOT_GAME" {...props} />
                ))}
              </div>
              <Text className="mb-2 mt-4 text-left text-base font-bold text-neon-blue">All games</Text>
              <div className="grid grid-cols-3 gap-4 pr-2">
                {props.allGames.map((g) => (
                  <GameContent key={`ALL_GAME_${g.id}`} game={g} category="ALL_GAME" {...props} />
                ))}
              </div>
            </VStack>
            <ScrollFixedView displayPosition="bottom" className="bottom-[76px]" />
            <Center className="relative mb-5">
              <PinkNeonButton
                onClick={props.onClickAccept}
                disabled={props.selectedGame === props.selectGame}
                px="px-4"
              >
                <Center className="px-10">
                  <Text className="text-xl font-bold text-white">Accept</Text>
                </Center>
              </PinkNeonButton>
            </Center>
            <Absolute className="bottom-2.5 right-2.5">
              <Clickable onClick={props.onClickClose}>
                <Center className="w-8">
                  <img src="/images/btn_cancel.png" alt="" />
                </Center>
              </Clickable>
            </Absolute>
          </VStack>
        </Fixed>
      ) : null}
    </>
  )
}

const GameContent = (props: Props & { game: GameInfo; category: GameCategory }) => {
  const { game, category, selectGame, onClickGame, selectCategory } = props
  const isSelected = game.id === selectGame && selectCategory === category
  return (
    <VStack>
      <Clickable
        onClick={() => onClickGame(game.id, category)}
        className={`relative aspect-square w-full rounded-[8px] border-2 ${
          isSelected ? 'border-akiverse-yellow' : 'border-transparent'
        }`}
      >
        <Image
          src={S3URLService.getGameThumbnailImageURL(props.game.id)}
          sizes="100%"
          layout="fill"
          alt={game.name}
          className={isSelected ? 'rounded-[8px]' : ''}
        />
      </Clickable>
      <Text className="mt-1 text-center text-[12px] font-semibold text-white">{game.name}</Text>
    </VStack>
  )
}
